import { Flex } from "@components/index";
import type React from "react";
import styles from "./MetaDay.module.scss";

interface MetaDayProps {
  level: Sentinel.Enumerators.TimelineGoal;
}

const MetaDay: React.FC<MetaDayProps> = ({ level }) => {
  const getRiskText = (level: Sentinel.Enumerators.TimelineGoal): string => {
    switch (level) {
      case "Achieved":
        return "Atingido";
      case "NotAchieved":
        return "Não atingido";
      case "InProgress":
        return "Em andamento";
      default:
        return "-";
    }
  };

  const getContainerClass = (
    level: Sentinel.Enumerators.TimelineGoal
  ): string => {
    switch (level) {
      case "Achieved":
        return `${styles.container} ${styles.achieved}`;
      case "NotAchieved":
        return `${styles.container} ${styles.notAchieved}`;
      case "InProgress":
        return `${styles.container} ${styles.inProgress}`;
      default:
        return `${styles.container}`;
    }
  };

  return (
    <Flex alignItems="center" gap="3px" className={getContainerClass(level)}>
      Meta do dia: <b> {getRiskText(level)}</b>
    </Flex>
  );
};

export default MetaDay;
